import React, { useEffect } from 'react';
import Moment from 'moment';
import {
  AppDatePicker,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';
import UserSelectStates from '../../../../components/form/Selects/UserSelectStates';

const Report36Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, handleOnSave, values } = props;
  const translations = {
    mode0: ReactDOMServer.renderToString(<Translator
      file='module-intelligence'
      name='module.int.mode-selected'
    />),
    mode1: ReactDOMServer.renderToString(<Translator
      file='module-intelligence'
      name='module.int.mode-plants'
    />),
    datePeriodNow: ReactDOMServer.renderToString(<Translator
      file='module-intelligence'
      name='module.int.xls.usedFilter-actualState'
    />),
    datePeriodBack: ReactDOMServer.renderToString(<Translator
      file='module-intelligence'
      name='module.int.xls.usedFilter-range'
    />),
    datePeriodEmpty: ReactDOMServer.renderToString(<Translator
      file='module-intelligence'
      name='module.int.empty-for-current'
    />),
  };

  useEffect(() => {
    handleOnSetFieldValue('mode', { value: 0, label: translations.mode0 });
    handleOnSetFieldValue('datePeriod', {
      value: 'now',
      label: translations.datePeriodNow,
    });
    handleOnSetFieldValue('from', Moment().format('DD/MM/YYYY'));
    handleOnSetFieldValue('to', Moment().format('DD/MM/YYYY'));
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <UserSelectStates
            onHandleChange={(opt) => {
              handleOnSetFieldValue('states', opt);
            }}
            value={values?.states}
            getPermissionsFrom="client"
            filteredStates={[2]}
            hasSelectOptions
            hideNotApplicable
            hideObsolete
          />
        </div>
      </div>
      {values.datePeriod &&
        values.datePeriod.value &&
        values.datePeriod.value === 'back' && (
          <div className="row">
            <div className="col-lg-6">
              <AppDatePicker
                title={
                  <Translator
                    file="module-lawFinder"
                    name="module.lf.filter.from"
                  />
                }
                value={values.from}
                onChange={(opt) => handleOnSetFieldValue('from', opt)}
                placeholder="dd/mm/yyyy"
                isClearable
                showMonthDropdown
                showYearDropdown
              />
            </div>
            <div className="col-lg-6">
              <AppDatePicker
                title={
                  <Translator
                    file="module-lawFinder"
                    name="module.lf.filter.to"
                  />
                }
                value={values.to}
                onChange={(opt) => handleOnSetFieldValue('to', opt)}
                placeholder="dd/mm/yyyy"
                isClearable
                showMonthDropdown
                showYearDropdown
              />
            </div>
          </div>
        )}
      <div className="row">
        <div className="col-12">
          <BtnOptions
            isDisabled={
              !values.states ||
              values.states.length === 0 ||
              (values.plants && values.plants.length === 0) ||
              !values.datePeriod ||
              (values.datePeriod.value === 'back' &&
                (!values.from || !values.to))
            }
            handleOnSave={() => handleOnSave(true)}
            handleOnSubmit={() => handleOnSubmit()}
          />
        </div>
      </div>
    </>
  );
};

export default Report36Options;
